<script>
// DeepLink 用なので特に何もしない
export default {}
</script>
